<mat-card class="default-card grid-all content-fit-height folder-tracking-customization-card">
    <mat-card-header>
        <mat-card-title><span class="title">Personnalisation du suivi de dossier.</span></mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content">
        @if (folderTrackingCustomization()) {
            <div class="form-panel-container">
                <form class="form">
                    <div class="form-container">
                        <div class="form-item">
                            <label>Titre</label>
                            <quill-editor
                                name="title"
                                [(ngModel)]="folderTrackingCustomization().title"
                                [modules]="editorModules"
                                theme="snow"
                                placeholder="Spécifier le titre à afficher pour le suivi de dossier..."
                                class="comment-editor"
                                [customOptions]="customOptions"></quill-editor>
                        </div>

                        <div class="form-item">
                            <label>Texte à afficher dans l'en-tête</label>
                            <quill-editor
                                name="headerText"
                                [(ngModel)]="folderTrackingCustomization().headerText"
                                [modules]="editorModules"
                                theme="snow"
                                placeholder="Spécifier le texte à afficher dans l'en-tête du suivi de dossier..."
                                class="comment-editor"
                                [customOptions]="customOptions"></quill-editor>
                        </div>

                        <div class="form-item">
                            <app-attributes-selector
                                title="Attributs à afficher dans l'en-tête"
                                [attributes]="attributes()"
                                [selectedAttributes]="headerAttributes()"
                                (attributesChanged)="onHeaderAttributesChanged($event)"></app-attributes-selector>
                        </div>

                        <app-step-customizations [steps]="steps" [stepCustomizations]="stepCustomizations"></app-step-customizations>
                        <div class="form-item">
                            <app-attributes-selector
                                title="Attributs à afficher dans le pied de page"
                                [attributes]="attributes()"
                                [selectedAttributes]="footerAttributes()"
                                (attributesChanged)="onFooterAttributesChanged($event)"></app-attributes-selector>
                        </div>

                        <div class="form-item">
                            <label>Texte à afficher dans le pied de page</label>
                            <quill-editor
                                name="footerText"
                                [(ngModel)]="folderTrackingCustomization().footerText"
                                [modules]="editorModules"
                                theme="snow"
                                placeholder="Spécifier le texte à afficher dansle pied de page du suivi de dossier..."
                                class="comment-editor"
                                [customOptions]="customOptions"></quill-editor>
                        </div>
                    </div>
                </form>
            </div>
        }
    </mat-card-content>
    <mat-card-actions class="single-child">
        <button mat-raised-button class="accent-button" (click)="onSave()">Sauvegarder</button>
    </mat-card-actions>
</mat-card>
